import React, { useEffect } from 'react';
import cn from 'classnames';

// CSS
import styles from '@UILayer/UILayer.scss';

// REDUX
import { useAppSelector } from '@Managers/Redux/Hooks';
import { getAuthenticateGameConfig, getDeviceInfo, getGlobalStyles } from '@Managers/Redux/AppState/AppState';
import { BonusBuyButton, MenuButton, SoundButton } from '@UILayer/Buttons';

//PANELS
import { BalanceInfo, BetInfo, BrandLogo, MaintananceBar, GamePlayInformation, WinningInformation, TimePanel, DemoModeInformation, GameNamePanel } from '..';
import ConfigLoader from '@ConfigLoader/ConfigLoader';
import { EConfigurationNames } from '@ConfigLoader/ConfigFiles';

const StatusHorizontal: React.FC<{}> = () => {
    const device = useAppSelector(getDeviceInfo);
    const globalStyles = useAppSelector(getGlobalStyles);
    const gameStoreAuthenticateGameConfig = useAppSelector(getAuthenticateGameConfig);
    const statusHorizontalCn = cn(
        styles.statusHorizontal_container,
        globalStyles.screenSize,
        globalStyles.wcaMode,
        globalStyles.handMode,
        globalStyles.isTablet
    );

    useEffect(() => {}, [device, globalStyles]);

    return (
        <>
            <div className={statusHorizontalCn}>
                {gameStoreAuthenticateGameConfig.bonusBuy && <BonusBuyButton />}
                <MaintananceBar />
                <div className={styles.statusHorizontal_top}>
                    <div className={styles.statusHorizontal_top_left}>
                        <DemoModeInformation />
                    </div>
                    <div className={styles.statusHorizontal_top_center}>
                        <WinningInformation />
                    </div>
                    <div
                        className={cn(
                            styles.statusHorizontal_top_right,
                            ConfigLoader.getConfiguration(EConfigurationNames.UI_LAYER).timePanel ? styles.timeStatus_enabled : styles.timeStatus_disabled
                        )}
                    >
                        <div className={styles.statusHorizontal_top_right_brand}>
                            <BrandLogo />
                        </div>
                        <div className={styles.statusHorizontal_top_right_info}>
                            <TimePanel />
                        </div>
                    </div>
                </div>
                <div className={styles.statusHorizontal_main}>
                    <div className={styles.statusHorizontal_left}>
                        <div className={styles.statusHorizontal_buttons_item}>
                            <MenuButton />
                            <SoundButton />
                        </div>
                        <div className={styles.statusHorizontal_group_item}>
                            <BalanceInfo />
                        </div>
                    </div>
                    <div className={styles.statusHorizontal_center}>
                        <GamePlayInformation />
                    </div>
                    <div className={styles.statusHorizontal_right}>
                        <div className={styles.statusHorizontal_group_item}>
                            <BetInfo />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StatusHorizontal;
